import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68d73396")

_pushScopeId("data-v-68d73396")
const _hoisted_1 = {
  key: 0,
  class: "display-user"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" L'utilisateur n'est pas encore validé et le lien d'activation a expiré. ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" L'utilisateur n'est pas encore validé. Pour finir son inscription l'utilisateur doit cliquer sur ")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "activate-link" }, "son lien d'activation", -1)
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-value" }
const _hoisted_10 = { class: "item-name" }
const _hoisted_11 = { class: "item-value" }
const _hoisted_12 = { class: "item-name" }
const _hoisted_13 = { class: "item-value" }
const _hoisted_14 = { class: "item-name" }
const _hoisted_15 = { class: "item-value" }
const _hoisted_16 = { class: "item-name" }
const _hoisted_17 = { class: "item-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($props.user)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!$props.user.activated)
          ? (_openBlock(), _createBlock("p", _hoisted_2, [
              ($setup.isLinkExpired($props.user.link))
                ? (_openBlock(), _createBlock("span", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("dig-ui-standard-button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.regenerateActiation())),
                      disabled: $setup.loading
                    }, " Regénérer le lien ", 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!$setup.isLinkExpired($props.user.link))
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("a", {
                      href: $props.user.link,
                      target: "_blank"
                    }, [
                      _hoisted_7
                    ], 8, ["href"]),
                    _createVNode("dig-ui-standard-button", {
                      disabled: $setup.loading,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.copyLink()))
                    }, " Copier le lien ", 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_8, _toDisplayString($setup.t('User.username')) + " : ", 1),
          _createVNode("span", _hoisted_9, _toDisplayString($props.user.username), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_10, _toDisplayString($setup.t('User.email')) + " : ", 1),
          _createVNode("span", _hoisted_11, _toDisplayString($props.user.email), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_12, _toDisplayString($setup.t('User.firstname')) + " : ", 1),
          _createVNode("span", _hoisted_13, _toDisplayString($props.user.firstname), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_14, _toDisplayString($setup.t('User.lastname')) + " : ", 1),
          _createVNode("span", _hoisted_15, _toDisplayString($props.user.lastname), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_16, _toDisplayString($setup.t('User.phone')) + " : ", 1),
          _createVNode("span", _hoisted_17, _toDisplayString($props.user.phone), 1)
        ])
      ]))
    : _createCommentVNode("", true)
})